<!--
sample usage in LecturerList/InnerHeader
-->
<script>
export default {
  data() {
    return {
      orderingField: null
    }
  },
  methods: {
    orderingToggle() {
      const current = this.getQueryParam('ordering')
      if (current === undefined) {
        this.setQueryParam('ordering', this.orderingField)
      } else if (current === this.orderingField) {
        this.setQueryParam('ordering', '-' + this.orderingField)
      } else {
        this.setQueryParam('ordering')
      }
    }
  },
  computed: {
    orderingIcon() {
      if (!this.orderingField) return
      const current = this.getQueryParam('ordering')
      if (current === undefined) {
        return 'sort-ascending'
      } else if (current === this.orderingField) {
        return 'sort-descending'
      } else {
        return 'stop'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  background: transparent;
}

.wrapper {
  display: flex;
  justify-content: space-between;
}

.ant-row-flex-multiline {
  margin-bottom: -16px;

  .ant-col {
    margin-bottom: 16px;
  }
}
</style>
